import cx from 'classnames';
import { Lock } from 'education-icons';
import React, { ReactNode } from 'react';

import { Button } from '../../button/button';
import { UI_KIT_TEXT_TYPOGRAPHY } from '../../constants';
import Text from '../../text/text';

import './showcase-lesson-teaser-card__preview.scss';

interface Props {
    children?: ReactNode;
    image?: string;
}

export const ShowcaseLessonTeaserCardPreview = ({ children, image }: Props) => (
    <div className="showcase-lesson-teaser-card__preview">
        <div
            className="showcase-lesson-teaser-card__image"
            style={{
                backgroundImage: image && `url(${image})`,
            }}
        >
            <div className="showcase-lesson-teaser-card__image-overlay" />
            <div className="showcase-lesson-teaser-card__image-content">{children}</div>
        </div>
        <div className="showcase-lesson-teaser-card__line" />
        <div className="showcase-lesson-teaser-card__line" />
        <div className={cx('showcase-lesson-teaser-card__line', 'showcase-lesson-teaser-card__line_short')} />
        <div className="showcase-lesson-teaser-card__unavailable-button">
            <Button
                disabled
                icon={<Lock className="showcase-lesson-teaser-card__unavailable-button-icon" />}
                transparencyTheme={Button.TRANSPARENCY_THEME.DARK}
                view={Button.VIEW.ACTION}
            />
            <Text
                className="showcase-lesson-teaser-card__unavailable-button-text"
                id="showcaseCard.giveout.unavailable"
                typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphLRegular}
            />
        </div>
    </div>
);
